import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersEmployeeConditionSubmissionsSubmissionRepliesUpdateRequestType,
  ApiMembersEmployeeConditionSubmissionsSubmissionRepliesUpdateResponseType,
} from "~/domains";

type RequestDataType = {
  employeeConditionSubmissionId: string;
  id: string;
  body: ApiMembersEmployeeConditionSubmissionsSubmissionRepliesUpdateRequestType;
};

const request = ({
  employeeConditionSubmissionId,
  id,
  body,
}: RequestDataType) => {
  return new ApiClient()
    .put<ApiMembersEmployeeConditionSubmissionsSubmissionRepliesUpdateResponseType>(
      `/api/members/employee_condition_submissions/${employeeConditionSubmissionId}/submission_replies/${id}`,
      {
        reply: body,
      },
    )
    .then((res) => res.data);
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApiMembersEmployeeConditionSubmissionsSubmissionRepliesUpdate =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ApiMembersEmployeeConditionSubmissionsSubmissionRepliesUpdateResponseType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
